import { render } from "./RequestList.vue?vue&type=template&id=6f83ac2f&scoped=true"
import script from "./RequestList.vue?vue&type=script&lang=js"
export * from "./RequestList.vue?vue&type=script&lang=js"

import "./RequestList.vue?vue&type=style&index=0&id=6f83ac2f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f83ac2f"]])

export default __exports__